import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function TextDecreaseIcon(props: IconProps) {
    return <Icon {...props} iconKey={"text_decrease"}/>
}
